import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../../utilities/masks";
import {
  selectIncidentOtherPersonsParticipantsData,
  selectIncidentOtherPersonsData,
  selectShouldDisplayOtherPersons,
  selectUIData,
  selectCircumAvailableCities,
} from "../incident.selectors";
import {
  setAvailableCities,
  setPersonsAreInvolved,
  setUIObjectField,
} from "../incident.slice";

import { ComponentId } from "./enums";

export const multiplePersonForm = (
  id: string
): FormSchema<SimpleFormSchemaComponents> => ({
  id,
  formId: FormId.INCIDENT_OTHER_PERSONS,
  selector: selectIncidentOtherPersonsParticipantsData,
  content: [
    {
      title: "Dane osoby",
      sections: [
        {
          id: ["persons-section-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][name]`,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][surname]`,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: ["persons-section-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)(
                `otherPersonspersons${id}phone`
              ),
              id: `persons[${id}][phone]`,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][email]`,
              label: "Email",
            },
          ],
        },
      ],
    },
    {
      title: "Miejsce zamieszkania",
      sections: [
        {
          id: ["persons-section-address-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street]`,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street2]`,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: ["persons-section-address-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: `persons[${id}][zipCode]`,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              type: FormElement.SELECT_CITY,
              id: `persons[${id}][city]`,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectCircumAvailableCities,
            },
          ],
        },
        {
          id: ["persons-section-address-data-3", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: `persons[${id}][role]`,
              required: true,
              label: "Jaki był udział tej osoby w zdarzeniu",
              items: [
                {
                  label: "świadek",
                  value: "Witness",
                },
                {
                  label: "uczestnik",
                  value: "Participant",
                },
                {
                  label: "inny",
                  value: "Other",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.INCIDENT_OTHER_PERSONS,
  selector: selectIncidentOtherPersonsData,
  content: [
    {
      sections: [
        {
          id: "incident-other-persons-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_OTHER_PEOPLE_INVOLVED,
              required: true,
              label: "Czy w zdarzeniu brały udział inne osoby?",
              onChange: setPersonsAreInvolved,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "incident-other-persons-data-2",
          isVisible: selectShouldDisplayOtherPersons,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MULTIPLE_PERSON,
              id: ComponentId.PERSONS,
              form: multiplePersonForm,
            },
          ],
        },
      ],
    },
  ],
};
